<div class="_anonymous-attendances-on-locations-statistic-component">

	<statistic-component 
		title="STATISTICS.ANONYMOUS_ATTENDANCES.LOCATIONS.TITLE"
		explanation="STATISTICS.ANONYMOUS_ATTENDANCES.LOCATIONS.EXPLANATION"
		[chartType]="'pie'"
		[dataRequest]="dataRequest"
		[params]="params"
		[canToggleLegend]="true"
	>
	</statistic-component>

</div>



